import { render } from "./PersonalizeProduct.vue?vue&type=template&id=721d677e&scoped=true"
import script from "./PersonalizeProduct.vue?vue&type=script&lang=js"
export * from "./PersonalizeProduct.vue?vue&type=script&lang=js"

import "./PersonalizeProduct.vue?vue&type=style&index=0&id=721d677e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721d677e"]])

export default __exports__